import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    static targets = [
        'badge',
    ];

    declare readonly badgeTarget: HTMLElement;
    declare readonly hasBadgeTarget: boolean;

    async markAsRead(event: Event) {

        event.preventDefault();

        const item = event.currentTarget as HTMLAnchorElement;

        const url = item.dataset.readUrl;

        if (!url) {
            return;
        }

        try {

            await fetch(url, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            // 🔥 eliminar visualmente la notificación
            item.remove();

            // 🔥 eliminar divider siguiente
            const divider = item.nextElementSibling;

            if (
                divider &&
                divider.classList.contains('dropdown-divider')
            ) {
                divider.remove();
            }

            // Actualizar badge
            if (this.hasBadgeTarget) {

                let count = parseInt(this.badgeTarget.innerText);

                count--;

                if (count <= 0) {

                    this.badgeTarget.remove();

                } else {

                    this.badgeTarget.innerText = count.toString();
                }
            }

            // navegar
            if (item.href && item.href !== '#') {

                window.location.href = item.href;
            }

        } catch (error) {

            console.error(error);

            if (item.href && item.href !== '#') {

                window.location.href = item.href;
            }
        }
    }
}